import { useRef } from "react";
import { ValuePropCard } from "./ValuePropCard";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

const VALUE_PROPS = [
  "UNYIELDING EXCELLENCE",
  "REFINED SIMPLICITY",
  "EXCEPTIONAL VALUE",
  "SOFTWARE THAT SUPPORTS OUR PHILOSOPHY",
];

export function ValueProps() {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: ".item", stagger: 0.15 });

  return (
    <section
      ref={sectionRef}
      id="section-three"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding">
        <div className="third-section">
          <div className="items-section">
            {VALUE_PROPS.map((title) => (
              <ValuePropCard key={title} title={title} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
